// extracted by mini-css-extract-plugin
export default {"mediaSideBar":"media_manager_sidebar_mediaSideBar__pxnR5","versionsSelected":"media_manager_sidebar_versionsSelected__J42Rw"};